import { testimonial } from '@/mocks/comics';

export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="w-full lg:w-3/5">
            <div className="flex items-center gap-2 mb-6">
              <div className="w-2 h-2 rounded-full bg-foreground-900"></div>
              <span className="text-xs font-semibold uppercase tracking-wider text-foreground-500">读者心声</span>
            </div>

            <blockquote className="mb-8">
              <div className="text-5xl md:text-6xl font-heading text-primary-300 leading-none mb-2">&ldquo;</div>
              <p className="text-lg md:text-xl lg:text-2xl font-heading text-foreground-900 leading-relaxed">
                {testimonial.quote}
              </p>
            </blockquote>

            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200">
                <img
                  src={testimonial.avatar}
                  alt={testimonial.author}
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-900">{testimonial.author}</p>
                <div className="flex items-center gap-1.5">
                  <span className="text-xs text-foreground-500">{testimonial.role}</span>
                  <span className="flex items-center gap-0.5 text-accent-500">
                    <i className="ri-verified-badge-fill text-xs"></i>
                    <span className="text-[10px] font-medium">叮当认证</span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-2/5 flex justify-center">
            <div className="relative w-48 h-64 md:w-56 md:h-72 rounded-lg overflow-hidden bg-gradient-to-br from-background-100 to-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20and%20friendly%20portrait%20of%20a%20young%20Chinese%20person%20reading%20a%20manga%20book%2C%20soft%20natural%20lighting%2C%20clean%20minimalist%20background%2C%20professional%20editorial%20photography%20style%2C%20warm%20tone%2C%20genuine%20expression%2C%20elegant%20composition&width=400&height=560&seq=testimonial-portrait&orientation=portrait"
                alt="叮当漫画网读者"
                title="叮当漫画网忠实读者"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}